import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../../../action';
import * as c from '../../../constant';

function MachinerySupersededAssessment({
  getMachineryRecordofSupAssessmentList,
  applicationId,
  dataList,
  isLoading,
}) {
  const [formData, setFormData] = useState({});

  const OnSetFormData = () => {
    if (dataList.length > 0) {
      setFormData({
        id: _.get(dataList, '0.id'),
        pin: _.get(dataList, '0.attributes.pin'),
        arp_no: _.get(dataList, '0.attributes.arp_no'),
        td_no: _.get(dataList, '0.attributes.td_no'),
        total_assessed_value: _.get(
          dataList,
          '0.attributes.total_assessed_value'
        ),
        previous_owner: _.get(dataList, '0.attributes.previous_owner'),
        effectivity_of_assessment: _.get(
          dataList,
          '0.attributes.effectivity_of_assessment'
        ),
        ar_page_no: _.get(dataList, '0.attributes.ar_page_no'),
        recording_person: _.get(dataList, '0.attributes.recording_person'),
        date: _.get(dataList, '0.attributes.date'),
      });
    }
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getMachineryRecordofSupAssessmentList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getMachineryRecordofSupAssessmentList(applicationId);
  }, [applicationId]);

  useEffect(() => {
    if (_.isEmpty(dataList)) {
      setFormData({});
    }
    if (!_.isEmpty(dataList)) {
      OnSetFormData();
    }
  }, [dataList]);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getMachineryRecordofSupAssessmentList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getMachineryRecordofSupAssessmentList(applicationId);
  }, [applicationId]);

  return (
    <>
      <div className="row px-3 py-3">
        {isLoading ? (
          <div
            className="col-12 d-flex justify-content-center align-items-center"
            style={{ height: '15rem' }}
          >
            <div className="loading">
              <div className="spinner text-center">
                <span className="fas fa-1x fa-spin fa-spinner" />
              </div>
            </div>
          </div>
        ) : (
          <>
            {_.isEmpty(dataList) ? (
              <div
                className="col-12 mt-1 d-flex justify-content-center align-items-center"
                style={{ height: '15rem' }}
              >
                <label className="mb-0 cit-label text-center">No Data</label>
              </div>
            ) : (
              <div className="col-12">
                <table className="transaction-table table table-borderless table-striped table-sm">
                  <tbody>
                    <tr>
                      <td className="span-title2 font-weight-bold" width="250">
                        ARP No.
                      </td>
                      <td className="text-dark" width="1" />
                      <td className="text-dark">
                        {_.get(formData, 'arp_no') || '--'}
                      </td>
                    </tr>
                    <tr>
                      <td className="span-title2 font-weight-bold" width="250">
                        PIN
                      </td>
                      <td className="text-dark" width="1" />
                      <td className="text-dark">
                        {_.get(formData, 'pin') || '--'}
                      </td>
                    </tr>
                    <tr>
                      <td className="span-title2 font-weight-bold" width="250">
                        TD No.
                      </td>
                      <td className="text-dark" width="1" />
                      <td className="text-dark">
                        {_.get(formData, 'td_no') || '--'}
                      </td>
                    </tr>
                    <tr>
                      <td className="span-title2 font-weight-bold" width="250">
                        Total Assessed Value
                      </td>
                      <td className="text-dark" width="1" />
                      <td className="text-dark">
                        {_.get(formData, 'total_assessed_value') || '--'}
                      </td>
                    </tr>
                    <tr>
                      <td className="span-title2 font-weight-bold" width="250">
                        Previous Owner
                      </td>
                      <td className="text-dark" width="1" />
                      <td className="text-dark">
                        {_.get(formData, 'previous_owner') || '--'}
                      </td>
                    </tr>
                    <tr>
                      <td className="span-title2 font-weight-bold" width="250">
                        AR Page No.
                      </td>
                      <td className="text-dark" width="1" />
                      <td className="text-dark">
                        {_.get(formData, 'ar_page_no') || '--'}
                      </td>
                    </tr>
                    <tr>
                      <td className="span-title2 font-weight-bold" width="250">
                        Effectivity of Assessment
                      </td>
                      <td className="text-dark" width="1" />
                      <td className="text-dark">
                        {_.get(formData, 'effectivity_of_assessment') || '--'}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <hr />
                      </td>
                    </tr>
                    <tr>
                      <td className="span-title2 font-weight-bold" width="250">
                        Recording Person
                      </td>
                      <td className="text-dark" width="1" />
                      <td className="text-dark">
                        {_.get(formData, 'recording_person') || '--'}
                      </td>
                    </tr>
                    <tr>
                      <td className="span-title2 font-weight-bold" width="250">
                        Date
                      </td>
                      <td className="text-dark" width="1" />
                      <td className="text-dark">
                        {_.get(formData, 'date') || '--'}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

MachinerySupersededAssessment.defaultProps = {
  applicationId: '',
};

MachinerySupersededAssessment.propTypes = {
  getMachineryRecordofSupAssessmentList:
    PropTypes.instanceOf(Function).isRequired,
  applicationId: PropTypes.string,
  dataList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList:
    _.get(api, `${c.GET_MACHINERY_RECORD_OF_SUP_ASSESSMENT}.list`) || [],
  isLoading:
    _.get(api, 'loading', []).indexOf(
      c.GET_MACHINERY_RECORD_OF_SUP_ASSESSMENT
    ) > -1,
  machinerySupersededAssessmentInfo:
    _.get(api, `${c.GET_SINGLE_MACHINERY_RECORD_OF_SUP_ASSESSMENT}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MachinerySupersededAssessment);
